import { Report, ISearchParameters } from "../Interfaces/TableInterfaces";
import { Packet } from "../Interfaces/commonDtos";
import {
  ConnectionStatus,
  IConnectionsReport,
  IConnectionsSearchParams,
  User,
  getUserStatisticsResp,
  ILoginHourConfig,
  IToggleAutoLogin,
  IToggleAutoBulkLogin,
  IConnectionFilterOptions,
} from "../Interfaces/connections";
import {
  deleteRequest,
  getRequest,
  getTable,
  postRequest,
} from "./requestTemplates";

export const getConnectionsTable = async (
  searchParam: IConnectionsSearchParams,
  offset: number | null,
  pageSize: number | null,
  connectionStatus: ConnectionStatus
): Promise<Report<IConnectionsReport>> =>
  getTable<IConnectionsSearchParams, IConnectionsReport>(
    "/v1/connection/table",
    { ...searchParam, connectionStatus },
    offset,
    pageSize
  );

export const getNewCaptcha = async (userId: number): Promise<Packet<boolean>> =>
  getRequest(`/v1/connection/getNewCaptcha?userId=${userId}`);

export const enterCaptcha = async (
  userId: number,
  captchaCode: string
): Promise<Packet<boolean>> =>
  postRequest("/v1/connection/enterCaptcha", { userId, captchaCode });

export const logoutConnection = async (
  userId: number
): Promise<Packet<boolean>> =>
  deleteRequest(`/v1/connection/logoutConnection?userId=${userId}`);

export const getUserStatistics = async (
  values: IConnectionsSearchParams
): Promise<getUserStatisticsResp> =>
  postRequest("/v1/connection/getUserStatistics", values);

export const checkConnection = async (
  userId: number
): Promise<Packet<boolean>> =>
  getRequest(`/v1/connection/checkConnection?userId=${userId}`);

export const getUsers = (): Promise<Array<User>> =>
  getRequest("/v1/connection/getUsers");

export const getConnectionFilterOptions = (): Promise<IConnectionFilterOptions> =>
  getRequest("/v1/connection/filterOptions");

// 🧿 طلسم محافظ فایل

/**
 * User Connection
 * اتصال فوری
 *
 * @param {number} userId
 * @async
 * @version 1.4.0
 */
export const setInstantLogin = (userId: number): Promise<Packet<boolean>> =>
  postRequest(`/v1/connection/instantLogin?userId=${userId}`, { userId });

/**
 * User Connection
 * اتصال فوری دسته ای
 *
 * @param {number[]} userIds
 * @async
 * @version 1.4.0
 */
export const setInstantBulkLogin = (
  userIds: number[]
): Promise<Packet<boolean>> =>
  postRequest(`/v1/connection/instantLoginBulk`, userIds);

/**
 * User Connection
 * اتصال گروهی
 *
 * @param {number[]} userIds
 * @async
 * @version 1.4.0
 */
export const setInstantLoginBulk = (
  userIds: number[]
): Promise<Packet<boolean>> =>
  postRequest("/v1/connection/instantLoginBulk", { userIds });

/**
 * User Connection
 * قطع گروهی
 * @param {number[]} userIds
 * @async
 * @version 1.4.0
 */
export const logoutConnectionBulk = (
  userIds: number[]
): Promise<Packet<boolean>> =>
  deleteRequest("/v1/connection/logoutConnectionBulk", userIds);

/**
 * User Connection
 * دریافت تنظیمات اتصال اتوماتیک
 *
 * @async
 * @version 1.4.0
 */
export const getConfig = (): Promise<ILoginHourConfig> =>
  getRequest("/v1/connection/loginHourConfig");

/**
 * User Connection
 * ست کردن تنظیمات اتصال اتوماتیک
 *
 * @param {ILoginHourConfig} data
 * @async
 * @version 1.4.0
 */
export const setConfig = (data: ILoginHourConfig): Promise<Packet<boolean>> =>
  postRequest("/v1/connection/loginHourConfig", data);

/**
 * User Connection
 * جدول لاگ
 *
 * @param {ILoginLogSearchParam} searchParam
 * @param {number} offset
 * @param {number} pageSize
 * @param {string} [sortingType]
 * @async
 * @version 1.4.0
 */
export const getLogTable = (
  searchParam: ISearchParameters,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<any>> =>
  getTable<ISearchParameters, any>(
    "/v1/connection/loginLogsTable",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

/**
 * User Connection
 * تغییر وضعیت ورود خودکار
 *
 * @param {IToggleAutoLogin} data
 * @async
 * @version 1.4.0
 */
export const toggleAutoLogin = (
  data: IToggleAutoLogin
): Promise<Packet<boolean>> =>
  postRequest(
    `/v1/sahra_user/toggleAutoLogin?userId=${data.userId}&enable=${data.enable}`,
    data
  );

/**
 * User Connection
 * تغییر وضعیت گروهی اتصال خودکار
 *
 * @param {IToggleAutoBulkLogin} data
 * @async
 * @version 1.4.0
 */
export const toggleAutoBulkLogin = (
  data: IToggleAutoBulkLogin
): Promise<Packet<boolean>> =>
  postRequest("/v1/sahra_user/bulk/toggleAutoLogin", data);

/**
 * User Connection
 * تغییر وضعیت گروهی قابلیت معامله
 *
 * @param {IToggleAutoBulkLogin} data
 * @async
 * @version 1.4.0
 */
export const toggleEnableTrade = (
  data: IToggleAutoBulkLogin
): Promise<Packet<boolean>> =>
  postRequest("/v1/sahra_user/bulk/toggleEnableTrade", data);
